import React from 'react';

interface Props {
    className?: string;
}

export const SearchIcon: React.FC<Props> = ({ className }) => {
    return (
        <svg className={`icon${className ? ` ${className}` : ''}`} width="20" height="20" viewBox="0 0 20 20">
            <path
                d="M19.7,18L16,14.3c1.1-1.5,1.8-3.4,1.8-5.4c0-4.9-4-8.9-8.9-8.9S0,4,0,8.9s4,8.9,8.9,8.9c2,0,3.9-0.7,5.4-1.8l3.7,3.7
                c0.5,0.5,1.2,0.5,1.7,0C20.1,19.2,20.1,18.4,19.7,18z M2.4,8.9c0-3.6,2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5s-2.9,6.5-6.5,6.5
                C5.3,15.5,2.4,12.5,2.4,8.9z"
            />
        </svg>
    );
};
